import React, { useEffect, useState } from "react";
import { Button, MenuItem, Select } from "@mui/material";
import "./ChangeStatus.css";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axiosApiInstance from '../axios';

const ChangeStatus = ({ onStatChange, info, stat, strtDate, setIsTicketStatusChanged }) => {
  // const [status, setStatus] = useState([]);
  const [statusId, setStatusId] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isStatus, setIsStatus] = useState([]);

  useEffect(() => {
    // add axios here
    axiosApiInstance.get(`/status`).then((req) => setIsStatus(req.data.data));
  }, []);

  let status = [];
  status = isStatus;

  status = status
    .filter((item) => {
      if (stat !== "Closed") {
        return item.name !== "Re-Opened";
      } else return item.name === "Re-Opened";
    })
    .map(({ id, name }) => {
      return { id, name };
    });

  const inputEvent = (event) => {
    if (event.target.value === 4) {
      setIsOpen(true);
    }

    setStatusId(event.target.value);
  };

  const closeModal = () => {
    setIsOpen(false);
    onStatChange();
  };

  const handleStart = (date) => {
    setStartDate(date);
  };

  const handleEnd = (date) => {
    setEndDate(date);
  };

  const SaveModal = () => {
    let data = JSON.stringify({
      ticketId: info,
      startDateTime: startDate,
      endDateTime: endDate,
    });

    axiosApiInstance.post('/ticket/AddEfforts', data).then(function (response) {
      console.log(JSON.stringify(response.data));
    });
    saveStat();
  };

  const saveStat = () => {
    let data = JSON.stringify({
      id: info,
      statusId: statusId,
    });

    axiosApiInstance.patch('/ticket/UpdateTicketStatus', data).then(function (response) {
      if (response.data.succeeded) {
        setIsTicketStatusChanged(true);
      }
      
    }).catch((error) => {
      console.error("Error:", error);
    });
    onStatChange();
  };

  return (
    <>
      <div>
        <Select className="selnextParty" value={statusId} onChange={inputEvent}>
          <MenuItem value="0" disabled>
            Edit
          </MenuItem>

          {status.map((stat, index) => (
            <MenuItem key={index} value={stat.id}>
              {stat.name}
            </MenuItem>
          ))}
        </Select>

        <Modal
          isOpen={isOpen}
          ariaHideApp={false}
          onRequestClose={closeModal}
          contentLabel="Modal"
          className="modal-popup"
          shouldCloseOnOverlayClick={false}
        >
          <p className="effort-time">
            PLEASE ENTER ACTUAL EFFORT SPEND ON TICKET
          </p>

          <div className="date-time">
            <div className="start-date-time">
              <label className="lab-datetime">Start DateTime</label>
              <DatePicker
                className="date-picker"
                selected={startDate}
                onChange={handleStart}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={20}
                timeCaption="time"
                dateFormat="MM-dd-yyyy h:mm aa"
                minDate={new Date(strtDate)}
              />
            </div>

            <div className="end-date-time">
              <label className="lab-datetime">End DateTime</label>
              <DatePicker
                className="date-picker"
                selected={endDate}
                onChange={handleEnd}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={1}
                timeCaption="time"
                dateFormat="MM-dd-yyyy h:mm aa"
                minDate={new Date()}
              />
            </div>
          </div>

          <div className="btn-save-close">
            <Button className="btn-time-save" onClick={SaveModal}>
              SAVE
            </Button>
            <Button className="btn-time-close" onClick={closeModal}>
              CLOSE
            </Button>
          </div>

        </Modal>
      </div>

      <div>
        <Button className="edit-save-btn" onClick={saveStat}>
          Save
        </Button>
        <Button className="edit-cancel-btn" onClick={onStatChange}>
          Cancel
        </Button>
      </div>

    </>
  );
};

export default ChangeStatus;
